import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import {
  actionCreators,
  IListingEditFiles,
  IListingEditState,
  selectError,
  selectFlyerFiles,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectListing,
  selectMarketingPackageFiles,
} from '../modules/listingEdit'
import ListingEdit from '../components/ListingEdit'
import { actionCreators as pipelineActionCreators } from '@app/components/PipelineEdit/modules/pipelineEdit'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { ListingType } from '@app/models/enums'
import { Assignment } from '@app/models/Assignment'
import { List } from 'immutable/dist/immutable-nonambient'

export interface ICriticalDates {
  criticalDates: List<{
    listingType: ListingType
    criticalDates: List<Assignment>
  }>
}

export default connect(
  createStructuredSelector<
    ApplicationState,
    IListingEditState & IListingEditFiles & IGlobalConfigurationState
  >({
    configuration: selectConfiguration(),
    error: selectError(),
    flyerFiles: selectFlyerFiles(),
    isLoading: selectIsLoading(),
    isReady: selectIsReady(),
    isSaving: selectIsSaving(),
    listing: selectListing(),
    marketingPackageFiles: selectMarketingPackageFiles(),
  }),
  {
    ...actionCreators,
    setCriticalDates: pipelineActionCreators.setCriticalDates,
  },
)(ListingEdit)
